<template>
  <div class="bmd-wrap">
    <h1>BMD – Import</h1>
  </div>
</template>

<script setup>
</script>

<style scoped>

</style>
